export function nameToAttributeKey(name) {
  const accentMap = {
    á: 'a', à: 'a', ã: 'a', â: 'a', ä: 'a',
    é: 'e', è: 'e', ê: 'e', ë: 'e',
    í: 'i', ì: 'i', î: 'i', ï: 'i',
    ó: 'o', ò: 'o', ô: 'o', õ: 'o', ö: 'o',
    ú: 'u', ù: 'u', û: 'u', ü: 'u',
    ç: 'c', ñ: 'n',
  };
  let out = '';
  let lastSep = false;
  const trimmed = String(name ?? '').trim();
  for (const ch of trimmed) {
    const lower = ch.toLowerCase();
    if (accentMap[lower]) {
      out += accentMap[lower];
      lastSep = false;
    } else if (/[a-z0-9]/.test(lower)) {
      out += lower;
      lastSep = false;
    } else if ((ch === ' ' || ch === '-' || ch === '_') && !lastSep) {
      out += '_';
      lastSep = true;
    }
  }
  return out.replace(/^_+|_+$/g, '');
}

export function createEmptyDraftAttribute(displayOrder = 0) {
  return {
    localId: `draft-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    name: '',
    is_variation: true,
    options: [],
    optionDraft: '',
    display_order: displayOrder,
  };
}

export function createDefaultVariationDraftFromItem(
  variationName = 'Variação',
  defaultOptionValue = 'Padrão',
) {
  const draft = createEmptyDraftAttribute(0);
  draft.name = String(variationName ?? '').trim() || 'Variação';
  const optionVal = String(defaultOptionValue ?? '').trim() || 'Padrão';
  const trimmedOption = optionVal.length > 80 ? optionVal.slice(0, 80) : optionVal;
  draft.options = [trimmedOption];
  const key = nameToAttributeKey(draft.name);
  return {
    draft,
    attributeValues: key ? { [key]: trimmedOption } : {},
  };
}

export function draftAttributeToPayload(draft, displayOrder) {
  const opts = (draft.options || []).map((o) => String(o).trim()).filter(Boolean);
  return {
    name: String(draft.name ?? '').trim(),
    is_customizable: false,
    is_variation: true,
    is_required: false,
    customizable_type: null,
    allow_other: false,
    display_order: displayOrder,
    options: opts.length > 0 ? opts : undefined,
    confirm_sku_reconcile: true,
  };
}

export function mergeCatalogWithDraftKeys(catalogAttributes, draftAttributes) {
  const catalog = Array.isArray(catalogAttributes) ? catalogAttributes : [];
  const drafts = Array.isArray(draftAttributes) ? draftAttributes : [];
  const synthetic = drafts
    .filter((d) => String(d.name ?? '').trim())
    .map((d) => {
      const key = nameToAttributeKey(d.name);
      return {
        id: d.localId,
        key,
        attribute_key: key,
        name: d.name.trim(),
        is_variation: true,
        is_required: false,
        is_customizable: false,
        options: (d.options || []).map((v) => ({ value: v })),
        _isDraft: true,
      };
    })
    .filter((a) => a.key);
  const catalogKeys = new Set(catalog.map((a) => a.key || a.attribute_key).filter(Boolean));
  const extra = synthetic.filter((a) => !catalogKeys.has(a.key));
  return [...catalog, ...extra];
}

export function catalogAttributesForSku(catalogAttributes) {
  const list = Array.isArray(catalogAttributes) ? catalogAttributes : [];
  return list.filter((a) => a.is_variation);
}

export function catalogAttributesRequiredForServerSku(catalogAttributes) {
  const list = Array.isArray(catalogAttributes) ? catalogAttributes : [];
  return list.filter(
    (a) => a.is_variation || (a.is_required && !a.is_customizable),
  );
}
